<template>
  <div>
    <grid-input
      ref="inputEditor"
      :value="localValue"
      type="text"
      text-align="start"
      :initial-select="false"
      :style="{height: '100%'}"
      @onInput="onInput"
    />

    <div
      :class="$style.grid_editor_date"
      :style="{
        top: coordinates.top,
        left: coordinates.left,
      }"
    >
      <vgp-date-picker
        :value="datePickerValue"
        :is-custom-date-column="true"
        :reset-button="true"
        :selected-date="selectedDate"
        :time-picker="false"
        @onChange="onSelectDate"
      >
        <template #footer="{ setValue }">
          <vgp-button
            style="margin-left: auto"
            type="text-blue"
            :small="true"
            :label="locales('datepiker_today')"
            data-testid="gp_autotest_gantt_grid_date_today_button"
            @onClick="() => setValue(new Date())"
          />
        </template>
      </vgp-date-picker>
    </div>
  </div>
</template>

<script>
import GridInput from './input.vue';
import vgpDatePicker from '$$vueCmp/datePicker/vgpDatePicker.vue';
import vgpButton from '$$uiKitComp/globalButton/vgpButton.vue';

export default {
  name: 'CustomDateCellEditor',
  components: { GridInput, vgpDatePicker, vgpButton },
  props: {
    placeholder: {
      type: Object,
      required: true,
    },
    selectedDate: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    datePickerValue: {
      type: [Date, String, Number],
      default: null,
    },
  },
  emits: [
    'onChange',
    'onInput',
  ],
  data() {
    return {
      locales: __,
      coordinates: {
        left: 'auto',
        top: 'auto',
      },
      localValue: null,
    };
  },
  watch: {
    value: {
      handler(val) {
        this.localValue = val;
      },
      immediate: true,
    },
  },
  created() {
    this.calcCoordinates();
  },
  mounted() {
    document.addEventListener('keydown', this.onKeyDown);
  },
  beforeUnmount() {
    document.removeEventListener('keydown', this.onKeyDown);
  },
  methods: {
    calcCoordinates() {
      const placeholderRect = this.placeholder.getBoundingClientRect();
      const gridResizerRect = document.querySelector('.gantt_layout_cell.gantt_resizer_x').getBoundingClientRect();
      const clientHeight = document.documentElement.clientHeight;
      const elementHeight = 308; const
        elementWidth = 258;
      let coords = { top: 0, left: 0 };

      const dropToBottom = (placeholderRect.bottom + elementHeight) < clientHeight;

      if (dropToBottom) {
        coords = {
          top: `${placeholderRect.bottom + 1}px`,
          left: `${placeholderRect.left}px`,
        };
      } else {
        coords = {
          top: `${placeholderRect.top - elementHeight - 2}px`,
          left: `${placeholderRect.left}px`,
        };
      }

      if (gridResizerRect.right < placeholderRect.left + elementWidth) {
        coords.left = `${placeholderRect.right - elementWidth - 2}px`;
      }

      this.coordinates = coords;
    },
    onInput(val) {
      this.$emit('onInput', val);
    },
    onSelectDate(value) {
      this.$emit('onChange', value);
    },
    onKeyDown(event) {
      if (event.keyCode === 13) { // enter
        this.$emit('onChange', this.localValue);
      }

      if (event.keyCode === 27) { // esc
        this.$emit('onCancel');
      }
    },
  },
};
</script>

<style module src="../styles/gridEditor.less" lang="less"></style>
